import React from "react";
import { StyleSheet, View, Text, TouchableHighlight } from "react-native";

import App from '../../App';

export default function PlaygroundScreen(props) {
    return (
        <View style={styles.main}>
            <Text> This is some text</Text>
            <TouchableHighlight
                style={styles.mybutton}
                onPress={App.toAccountPage}
            >
                <Text> Home </Text>
            </TouchableHighlight>
        </View>
    );
}

const styles = StyleSheet.create({
    main: {
        backgroundColor: 'red',
        height: "100%",
        width: "100%",
    },

    mybutton: {
        height: 100,
        width: 200,
        backgroundColor: 'green',
    }
})